import React from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonSizes } from '../../button';
import Tooltip from '../../tooltip';

const RenButton = ({ data, accessor, onAction }) => {
  if (!data[accessor]) return null;

  const getButton = (
    <div className="tbl-ren-button">
      <Button
        size={ButtonSizes.SMALL}
        onClick={onAction}
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...data[accessor]}
      />
    </div>
  );

  return data[accessor]?.description ? (
    <Tooltip title={data[accessor]?.description}>
      {getButton}
    </Tooltip>
  ) : getButton;
};

RenButton.defaultProps = {
  data: {},
  onAction: () => {},
};

RenButton.propTypes = {
  id: PropTypes.string.isRequired,
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
  onAction: PropTypes.func,
};

export default RenButton;
